import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Import all required components */
import {LoginComponent} from './login/login.component';
import {ResetpasswordComponent} from './resetpassword/resetpassword.component';
import {SetpasswordComponent} from './setpassword/setpassword.component';
import {LandingpageComponent} from './home/landingpage.component';

/* Import auth guard service */
import { AuthGuard } from './auth/auth.guard';

/* Import role guard service */
import { RoleGuard } from './auth/role.guard';

/* If role guard is need to implement, please put these lines in router item
* canActivate: [RoleGuard],
* data: {
*   expectedRole: '[ROLE_NAME]'
* }
*/
const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  { path: 'login',
    component: LoginComponent
  }
  ,
   { path: 'resetpass/:token',
    component: ResetpasswordComponent
  }
  ,
  { path: 'setpass/:token',
    component: SetpasswordComponent
  },
  { path: 'home',
    component: LandingpageComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
